<template>
    <div class="pluralo d-flex">
        <pill></pill>

        <sidebar></sidebar>

        <section class="d-flex flex-column">
            <div>
                <bar></bar>
                <topbar-message></topbar-message>
            </div>

            <router-view class="flexGrow1" @click.native="clickOnContentArea()"></router-view>
        </section>

        <modal-wrapper></modal-wrapper>

        <floating-notifications v-if="showNotifications"></floating-notifications>

    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import topbarMessage from '@/tools/topbarMessage'
    import Sidebar from '../common/Sidebar.vue'
    import Bar from '../common/Bar.vue'
    import Pill from '@/tools/Pill'
    import ModalWrapper from '@/tools/modal/ModalWrapper.vue'
    import floatingNotifications from '@/tools/notifications/floatingNotifications/floatingNotifications'

    export default {
        computed: {
            ...mapGetters([
                'getIsBellNotificationOpen'
            ]),
            showNotifications: function () {
                //hide from viewer
                return !this.accessPermissionFilter(['viewer'])
            }
        },
        methods: {
            ...mapActions([
                'toggleBellNotificationPopup',
            ]),
            clickOnContentArea: function () {
                if(this.getIsBellNotificationOpen == true){
                    this.toggleBellNotificationPopup(false)
                }
            }
        },
        components: {
            Pill,
            Bar,
            Sidebar,
            ModalWrapper,
            topbarMessage,
            floatingNotifications
        },
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// Pluralo.vue?20e584b2